import { ElementApi,type OverrideEditor } from '@udecode/plate';

import type { BaseFootnotesConfig } from './BaseFootnotesPlugin';

export const withFootnotes: OverrideEditor<BaseFootnotesConfig> = ({
    tf: { apply, setNodes, withoutNormalizing },
    api,
    getOption,
    setOption,
    type,
}) => {
    const reindexFootnotes = () => {
        const allNodes = api.footnotes.getAll();

        withoutNormalizing(() => {
            allNodes.forEach(([ , path ], index) => {
                setNodes({
                    index
                }, { at: path });
            });

            api.footnotes.setFootnoteCount(allNodes.length);
        });

        setOption('_changeRev', getOption('_changeRev') + 1);
    };

    return {
        transforms: {
            // Disabled because it's causes the editor to re-sync (=save) every time the editor is loaded without user interaction.
            // normalizeNode: (node) => {
            //     normalizeNode(node);
                            
            //     if (node[0] && node[0].type === type) {
            //         reindexFootnotes();
            //     }
            // },
            apply: (op) => {
                apply(op);

                const isFootnote = ElementApi.isElement(op.node) && op.node.type === type;
                const containsFootnotes = ElementApi.isElement(op.node) && op.node.children.some(child => ElementApi.isElement(child) && child.type === type);

                if (isFootnote || containsFootnotes) {
                    reindexFootnotes();
                }

                if (op.type === 'set_node' && 'footnotes' in op.newProperties) {
                    setOption('_changeRev', getOption('_changeRev') + 1);   
                }
            }
        },
    };
};
